import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { MediaService } from '../../../_services/index';

import { map, take, first } from 'rxjs/operators';

@Component({
    selector: 'ngx-select-media-modal',
    templateUrl: 'select-media-modal.component.html',
    styleUrls: ['select-media-modal.component.scss'],
    standalone: false
})
export class SelectMediaModalComponent {

  @Input() gameId;
  @Input() templateId;

  context = 'game';

  medias = [];
  filteredMedias = [];

  loading;
  searchText;

  constructor(protected ref: NbDialogRef<SelectMediaModalComponent>,
    public mediaService: MediaService) {}

  ngOnInit(){
    if(!this.gameId){
      this.context = 'template';
    }
    this.loadMedias();
  }

  getStoragePath(){
    if(this.context == 'game'){
      return `games/${this.gameId}/medias`;
    }
    else{
      return `game_templates/${this.templateId}/medias`;
    }
  }

  switchContext(){
    this.context = (this.context == 'game') ? 'template' : 'game';
    this.loadMedias();
  }

  loadMedias(){
    this.loading = true;
    console.log('Load medias from:'+this.getStoragePath());
    this.mediaService.listMedias(this.getStoragePath())
    .pipe(take(1))
      .subscribe(medias => {
        this.medias = medias;
        this.loading = false;
        this.search();
      });
  }

  search(){
    this.filteredMedias = this.medias.filter(media => {
      return !this.searchText || ((media.description || '')+(media.searchTerms || '')).indexOf(this.searchText)>=0;
    })
  }

  cancel() {
    this.ref.close();
  }

  select(media){
    this.ref.close(media);
  }
}
